/**
 * PropertyCheckLanding — redirect shim.
 *
 * The standalone marketing landing was removed. `/property-check` now sends
 * visitors straight into the booking funnel (`/property-check/book`), and
 * already-authenticated owners to their dashboard.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const PropertyCheckLanding = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;
    navigate(isAuthenticated ? '/property-check/dashboard' : '/property-check/book', {
      replace: true,
    });
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
      <CircularProgress />
    </Box>
  );
};

export default PropertyCheckLanding;
